// const apiBaseUrls = "http://192.168.1.19:5000/";
// export const imageBaseUrls = "http://192.168.1.19:5000/assets/";
// const mainUrl = "";

// const apiBaseUrls = "http://191.101.80.117:5000/";


const apiBaseUrls = `${process.env.REACT_APP_API_URL}/`;
// const apiBaseUrls = "https://chriskelly.xyz/backend/";
// const apiBaseUrls = "http://localhost:5000/";

// export const imageBaseUrls = `${apiBaseUrls}assets/`;

export const imageBaseUrls = (url, options = {}) => {
    const {
        width = 500,
        height,
        quality = "auto",
        format = "auto"
    } = options;

    // fallback (no url)
    if (!url) {
        return `${apiBaseUrls}assets/`;
    }

    // already full URL
    if (url.startsWith("https://") || url.includes("cloudinary")) {

        // ✅ Cloudinary optimization
        if (url.includes("cloudinary")) {
            const transformations = [
                `f_${format}`,
                `q_${quality}`,
                width ? `w_${width}` : "",
                height ? `h_${height}` : "",
                "c_fill"
            ]
                .filter(Boolean)
                .join(",");

            return url.replace("/upload/", `/upload/${transformations}/`);
        }

        return url;
    }

    // local assets
    return `${apiBaseUrls}assets/${url}`;
};

export const webSiteUrl = `${process.env.REACT_APP_WEBSITE_URL}/`;
export const dealerUrl = `${process.env.REACT_APP_DEALER_URL}/`;

// const apiBaseUrls = "http://localhost:5000/";
// export const imageBaseUrls = "http://localhost:5000/assets/";


export const ApiURLs = {
    login: `${apiBaseUrls}admin/auth/login`,
    CHANGE_PASSWORD: `${apiBaseUrls}admin/auth/change-password`,
    RESET_NEW_PASSWORD: `${apiBaseUrls}admin/auth/reset-new-password`,
    EDIT_PROFILE: `${apiBaseUrls}admin/auth/edit-profile`,
    UPLOAD_IMAGE_OLD: `${apiBaseUrls}api/upload-image`,
    UPLOAD_IMAGE: `${apiBaseUrls}api/upload-image-cloudinary`,

    UPLOAD_CHUNK: `${apiBaseUrls}api/upload-chunk`,
    MERGE_CHUNK: `${apiBaseUrls}api/merge-chunk`,

    FORGOT_PASSWORD: `${apiBaseUrls}admin/auth/forgot-password`,
    GET_USERS: `${apiBaseUrls}admin/user`,
    GET_DEALERS: `${apiBaseUrls}admin/dealers`,
    GET_OPENING_HOURS: `${apiBaseUrls}admin/opening-hours`,
    DELETE_USER: `${apiBaseUrls}admin/user-delete`,
    USER_UPDATE: `${apiBaseUrls}admin/user-update`,
    EMAIL_UPDATE: `${apiBaseUrls}admin/updateEmail`,
    CATEGORIES: `${apiBaseUrls}admin/category`,
    KEYWORDS: `${apiBaseUrls}admin/keywords`,
    KEYWORDSBULK: `${apiBaseUrls}admin/keywords-bulk`,

    ATTRIBUTE: `${apiBaseUrls}admin/attribute`,
    REORDER_ATTRIBUTE: `${apiBaseUrls}admin/reorder-attribute`,

    PLAN: `${apiBaseUrls}admin/plan`,
    TIER: `${apiBaseUrls}admin/tier`,

    BANK: `${apiBaseUrls}admin/bank`,
    SOLD_ADS: `${apiBaseUrls}admin/sold-ads`,
    REMOVED_EXPIRED_ADS: `${apiBaseUrls}admin/removed-expired-ads`,

    ADMIN: `${apiBaseUrls}admin/admin`,

    VEHICLES: `${apiBaseUrls}admin/vehicles`,
    SUSPISIOUS: `${apiBaseUrls}admin/suspicious-activity`,
    FINANCE: `${apiBaseUrls}admin/finance`,

    CONTACTUS: `${apiBaseUrls}admin/contact-us`,
    VEHICLESBULK: `${apiBaseUrls}admin/vehicles-bulk`,
    SETTINGS: `${apiBaseUrls}admin/setting`,
    GDPR: `${apiBaseUrls}admin/gdpr`,
    DASHBOARD: `${apiBaseUrls}admin/dashboard`,
    DASHBOARD_DEALER: `${apiBaseUrls}admin/dashboard-dealer`,

    ABOUT: `${apiBaseUrls}admin/about`,
    MEMBERS: `${apiBaseUrls}admin/members`,
    FEATURES: `${apiBaseUrls}admin/features`,

    CARREVIEW: `${apiBaseUrls}admin/car-review`,
    CARREVIEWFEATURE: `${apiBaseUrls}admin/car-review-features`,

    ANALYSIS: `${apiBaseUrls}admin/analysis`,
    VEHICLE_MAKE: `${apiBaseUrls}admin/vehicles-make-model`,
    SYNC_VEHICLES_DATA: `${apiBaseUrls}admin/sync-vehicles-data`,
    VEHICLE_MAKE_BULK: `${apiBaseUrls}admin/vehicles-make-model-bulk`,
    BLOG: `${apiBaseUrls}admin/blog`,
    ARTICLE: `${apiBaseUrls}admin/article`,
    ARTICLE_CATEGORIES: `${apiBaseUrls}admin/article-categories`,

    FAQS: `${apiBaseUrls}admin/faq`,
    ADMIN_DETAIL: `${apiBaseUrls}admin/admin-detail`,

    ADREPORTS: `${apiBaseUrls}admin/ad-report`,
    ADS: `${apiBaseUrls}admin/ads`,


    CREATEDEALER: `${apiBaseUrls}admin/create-dealer`,
    UPDATEDEALER: `${apiBaseUrls}admin/update-dealer`,
    ADD_BUMP_SPOTLIGHT: `${apiBaseUrls}admin/add-bump-spotlight`,

    // ADD_CATEGORY:`${apiBaseUrls}admin/category`,
};